import { render } from "./KanbanTransitionModal.vue?vue&type=template&id=2a3cda82&scoped=true"
import script from "./KanbanTransitionModal.vue?vue&type=script&lang=js"
export * from "./KanbanTransitionModal.vue?vue&type=script&lang=js"

import "./KanbanTransitionModal.vue?vue&type=style&index=0&id=2a3cda82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3cda82"]])

export default __exports__